function TableLayout({ data }) {
  return (
    <div className="w-full overflow-x-auto table-scrollbar">
      <table className="bg-gray-50 w-full min-w-[1000px]   border-collapse">
                <thead>

        <tr className="bg-[#f3ebfa] w-full ">
          {data.tableData.thead.map((heading, i) => (
            <th key={i} className="text-start px-10 py-4 text-lg  md:text-xl text-dark whitespace-nowrap">{heading}</th>
          ))} 
        </tr>
                </thead>
 
        <tbody>

       {data.tableData.tbody.map((row, rowIndex) => {
  const isFirst = rowIndex === 0;
  const isLast = rowIndex === data.tableData.tbody.length - 1;

  // Base padding for all cells
  const rowPadding = `${
    isFirst ? "pt-8" : ""
  } ${isLast ? "pb-8" : ""}`;

  return (
    <tr key={rowIndex} className="w-full">
      {row.map((cell, colIndex) => (
        <td
          key={colIndex}
          className={`px-10 py-2 text-base leading-[1.625rem] text-dark font-semibold ${rowPadding}`}
        >
          {cell}
        </td>
      ))}
    </tr>
  );
})}
                </tbody>
 
      </table> 
    </div>
  ); 
}

export default TableLayout;
